export const downloadB64File = (link: string) => {
  let a = document.createElement('a');

  a.href = `${link}`;
  a.click();
};
